import { useSelector } from 'react-redux';

import { useEffect } from 'react';
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline, StyledEngineProvider } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import AOS from 'aos';

// routing
import Routes from 'routes';

// defaultTheme
import 'animate.css';
import 'aos/dist/aos.css';
import themes from 'themes';

// project imports
import NavigationScroll from 'layout/NavigationScroll';

const RECAPTCHA_KEY = '6LfcsQ8pAAAAAMRVTewti8TquJaQppE6g-bqXd0w'; // process.env.REACT_APP_RECAPTCHA_KEY;

// ==============================|| APP ||============================== //

const App = () => {
  const customization = useSelector((state) => state.customization);

  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <GoogleReCaptchaProvider reCaptchaKey={RECAPTCHA_KEY}>
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={themes(customization)}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <CssBaseline />
            <NavigationScroll>
              <Routes />
            </NavigationScroll>
          </LocalizationProvider>
        </ThemeProvider>
      </StyledEngineProvider>
    </GoogleReCaptchaProvider>
  );
};

export default App;
